import { render, staticRenderFns } from "./software-report.vue?vue&type=template&id=18f2e35e&"
import script from "./software-report.vue?vue&type=script&lang=js&"
export * from "./software-report.vue?vue&type=script&lang=js&"
import style0 from "./software-report.vue?vue&type=style&index=0&lang=css&"
import style1 from "./software-report.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports